import { useQuery } from "@tanstack/react-query";
import {
  get4AK1Badges,
  get4AK1BadgesByItemNo,
} from "../services/articles.service";
import { QueryKeys } from "./queryKeys";

export const use4AK1ArticlesData = (
  itemNos: string | undefined,
  countryId: string | undefined,
  enabled = true
) => {
  return useQuery({
    queryKey: [QueryKeys.Badge4AK1Articles, itemNos, countryId],
    queryFn: () => get4AK1BadgesByItemNo(itemNos || "", countryId || ""),
    enabled: enabled && !!itemNos && !!countryId,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours cache time
    staleTime: 1000 * 60 * 60 * 24, // 24 hours stale time
  });
};

export const use4AK1ArticleData = (
  articleId: string | undefined,
  countryId: string | undefined,
  enabled = true
) => {
  return useQuery({
    queryKey: [QueryKeys.Badge4AK1Article, articleId, countryId],
    queryFn: () => get4AK1Badges(articleId || "", countryId || ""),
    enabled: enabled && !!articleId && !!countryId,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours cache time
    staleTime: 1000 * 60 * 60 * 24, // 24 hours stale time
  });
};
